/* eslint-disable jsx-a11y/anchor-has-content */
import React, { ReactElement, useEffect, useState } from 'react';
import { DataView } from 'primereact/dataview';
import { Paginator } from 'primereact/paginator';
import { gql, useQuery } from '@apollo/client';

import ProjectViewSkeleton from './ProjectViewSkeleton';
import './ProjectView.scss';
import '../Table/Paginator.scss';
import '../home/home.scss';
import ProjectViewGridItem from './ProjectViewGridItem';

const PROJECT_QUERY = gql`
  query projects($filter: ProjectFilter, $offset: Int, $limit: Int) {
    getPublicProjects(filter: $filter, offset: $offset, limit: $limit) {
      projects {
        id
        name
        address
        url
        zip
        city
        images {
          path
        }
      }
      count
    }
  }
`;

export interface ProjectFilters {
  zip: string[];
  metro: string[];
  // eslint-disable-next-line camelcase
  kaufen_mieten: string[];
  // eslint-disable-next-line camelcase
  planung_bau: string[];
}

interface ProjectViewProps {
  filter: ProjectFilters;
}

const ProjectView = (props: ProjectViewProps): ReactElement => {
  const { filter } = props;

  const [offset, setOffset] = useState(0);

  useEffect(() => {
    setOffset(0);
  }, [filter]);
  const pageSize = 9;
  const { loading, data } = useQuery(PROJECT_QUERY, {
    variables: { filter, offset, limit: pageSize },
  });

  return (
    <>
      {(loading || !data) && <ProjectViewSkeleton />}
      {!loading && data && (
        <div className="projectViewWrapper">
          <DataView
            value={data.getPublicProjects.projects}
            layout="grid"
            itemTemplate={ProjectViewGridItem}
            rows={9}
            emptyMessage="Keine Neubauprojekte verfügbar"
          />
          <Paginator
            rows={9}
            first={offset}
            totalRecords={data.getPublicProjects.count}
            onPageChange={(e) => {
              if (e.first === offset) {
                return;
              }
              setOffset(e.first);
            }}
          />
        </div>
      )}
    </>
  );
};

export default ProjectView;
